import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import 'flatpickr/dist/flatpickr.min.css';
import './index.css';

import App from './App';
import ErrorHandler from './ErrorHandler';
import Loading from './Loading';
import { store } from './store';

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(container!).render(
  <React.StrictMode>
    <ErrorHandler>
      <Provider store={store}>
        <BrowserRouter>
          <Toaster position="top-right" toastOptions={{ duration: 2500 }} />
          <Suspense fallback={<Loading />}>
            <App />
          </Suspense>
        </BrowserRouter>
      </Provider>
    </ErrorHandler>
  </React.StrictMode>,
);
